import React, { createContext } from "react";
import {
  IBusinessContextData,
  IBusinessContext,
} from "../type/contextType/businessContextType";

// Contextオブジェクトを作成する
export const BusinessContext = createContext<{
  state: IBusinessContextData;
  setState: (data: IBusinessContextData) => void;
}>({
  state: {},
  setState: (data: IBusinessContextData) => {},
});

// Providerコンポーネントを作成し、子コンポーネントにContextデータを提供する
export const BusinessContextProvider: React.FC<IBusinessContext> = (props) => {
  const [state, setState] = React.useState<IBusinessContextData>({});

  return (
    <BusinessContext.Provider value={{ state, setState }}>
      {props.children}
    </BusinessContext.Provider>
  );
};

export default BusinessContextProvider;
